export const toSeoFriendlyUrl = (text: string): string => {
  return text
    .toLowerCase()
    // Replace spaces and special characters with hyphens
    .replace(/[^a-z0-9]+/g, '-')
    // Remove hyphens from start and end
    .replace(/^-+|-+$/g, '');
};

export const fromSeoFriendlyUrl = (slug: string): string => {
  return decodeURIComponent(slug)
    // Replace hyphens with spaces
    .replace(/-/g, ' ')
    // Capitalize first letter of each word
    .replace(/\b\w/g, c => c.toUpperCase());
}; 